module.exports = __webpack_public_path__ + "static/media/top-right.c6422a7f.svg";